import { useQueryClient } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { FiFileText, FiPieChart, FiSliders } from "react-icons/fi"
import type { UserPublic } from "../../../../client"
import {
  type ProductionModuleCard,
  ProductionModuleHubPage,
} from "../../../../components/WMS/ProductionNavigation/ProductionModuleHubPage"
import { hasPermission } from "../../../../utils/roles"

export const Route = createFileRoute("/_layout/WMS/auto-replenishment/")({
  component: AutomationHubRoute,
})

function AutomationHubRoute() {
  const queryClient = useQueryClient()
  const currentUser = queryClient.getQueryData<UserPublic>(["currentUser"])
  const cards: ProductionModuleCard[] = []

  if (
    hasPermission(currentUser, "wms.auto_replenishment.request.read") ||
    hasPermission(currentUser, "wms.auto_replenishment.worker.run") ||
    hasPermission(currentUser, "wms.auto_replenishment.policy.read")
  ) {
    cards.push({
      title: "Automatyczne uzupełnianie",
      description:
        "Monitoruj działanie procesu, grupy zapotrzebowania i bieżące wyniki.",
      to: "/WMS/auto-replenishment/overview",
      icon: FiPieChart,
    })
  }

  if (
    hasPermission(currentUser, "wms.auto_replenishment.policy.read") ||
    hasPermission(currentUser, "wms.auto_replenishment.policy.create") ||
    hasPermission(currentUser, "wms.auto_replenishment.policy.update")
  ) {
    cards.push({
      title: "Polityki automatycznego uzupełniania",
      description:
        "Konfiguruj progi, technologie i magazyny używane przez automatyzację.",
      to: "/WMS/auto-replenishment/policies",
      icon: FiSliders,
    })
  }

  if (hasPermission(currentUser, "wms.auto_replenishment.request.read")) {
    cards.push({
      title: "Zgłoszenia automatycznego uzupełniania",
      description:
        "Przeglądaj utworzone zgłoszenia, ich status i powiązane dokumenty.",
      to: "/WMS/auto-replenishment/requests",
      icon: FiFileText,
    })
  }

  return (
    <ProductionModuleHubPage
      title="Automatyzacja"
      description="Monitorowanie, konfiguracja i obsługa automatycznego uzupełniania zapasów."
      cards={cards}
    />
  )
}
